import { Injectable } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';

import { FileInputType } from '../enums';
import { FileInputComponent } from '../components/file-input/file-input.component';

@Injectable()
export class FormUtility {
  constructor(private dialog: MatDialog) {}

  getFormControl(formGroup: FormGroup, name: string): FormControl {
    return formGroup.get(name) as FormControl;
  }

  getFormArrayControls(formGroup: FormGroup, name: string): FormControl[] {
    return (formGroup.get(name) as FormArray)?.controls as FormControl[];
  }

  openFileInputDialog(
    data: Partial<{
      multiple: boolean;
      type: FileInputType;
      maxSize: number; // size in MBs
      browseLabel: string;
      submitLabel: string;
      text: string;
      color: 'primary' | 'secondary' | 'tertiary' | 'neutral';
    }>,
  ): Observable<File | File[]> {
    const dialogRef = this.dialog.open(FileInputComponent, {
      width: '500px',
      height: '350px',
      disableClose: true,
      closeOnNavigation: true,
      data: { ...data, isDialog: true },
    });

    return dialogRef.afterClosed();
  }
}
